import { render } from "./ProductExchangeFormModal.vue?vue&type=template&id=18cb6b46"
import script from "./ProductExchangeFormModal.vue?vue&type=script&lang=js"
export * from "./ProductExchangeFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__